export const COACH_TIMEFRAME = {
  IMMEDIATELY: "IMMEDIATELY",
  WITHIN_MONTH: "WITHIN_MONTH",
  ONE_TO_THREE_MONTHS: "ONE_TO_THREE_MONTHS",
  THREE_TO_SIX_MONTHS: "THREE_TO_SIX_MONTHS",
  SIX_TO_TWELVE_MONTHS: "SIX_TO_TWELVE_MONTHS",
  OVER_A_YEAR: "OVER_A_YEAR",
} as const;

export type CoachTimeframe = (typeof COACH_TIMEFRAME)[keyof typeof COACH_TIMEFRAME];

export const COACH_MAIN_FOCUS = {
  FAST_COMPLETION: "FAST_COMPLETION",
  ONLINE: "ONLINE",
  FLEXIBLE_SCHEDULE: "FLEXIBLE_SCHEDULE",
  QUALITY: "QUALITY",
  LOW_COST: "LOW_COST",
  FOR_CREDIT: "FOR_CREDIT",
  EASE_OF_ENROLLING: "EASE_OF_ENROLLING",
} as const;

export type CoachMainFocus = (typeof COACH_MAIN_FOCUS)[keyof typeof COACH_MAIN_FOCUS];

export const COACH_FURTHER_EDUCATION_REASON = {
  CHANGE_CAREER: "CHANGE_CAREER",
  PROGRESS_CAREER: "PROGRESS_CAREER",
  LEARN_SKILLS: "LEARN_SKILLS",
  BETTER_ROLE_MODEL: "BETTER_ROLE_MODEL",
  INCREASE_EARNINGS: "INCREASE_EARNINGS",
  SKIP: "SKIP",
} as const;

export type CoachFurtherEducationReason =
  (typeof COACH_FURTHER_EDUCATION_REASON)[keyof typeof COACH_FURTHER_EDUCATION_REASON];

export const SKIPPER_CUSTOMER_DETAIL = {
  DEGREE_LEVEL_INTEREST: "DEGREE_LEVEL_INTEREST",
  FURTHER_EDUCATION_REASON: "FURTHER_EDUCATION_REASON",
  INDUSTRY_INTEREST: "INDUSTRY_INTEREST",
  MAIN_FOCUS: "MAIN_FOCUS",
  SUBINDUSTRY_INTEREST: "SUBINDUSTRY_INTEREST",
  TIMEFRAME_PREFERENCE: "TIMEFRAME_PREFERENCE",
} as const;

export const CAREER_GOAL = {
  SWITCH_CAREERS: "SWITCH_CAREERS",
  ADVANCE_IN_FIELD: "ADVANCE_IN_FIELD",
  GAIN_NEW_SKILLS: "GAIN_NEW_SKILLS",
  EXPLORE_OPTIONS: "EXPLORE_OPTIONS",
} as const;

export type CareerGoal = (typeof CAREER_GOAL)[keyof typeof CAREER_GOAL];

export const CAREER_CHANGE_CONCERN = {
  EDUCATION_COST: "EDUCATION_COST",
  TIME_COMMITMENT: "TIME_COMMITMENT",
  CHANGE_RISK: "CHANGE_RISK",
  MAY_NOT_LIKE_IT: "MAY_NOT_LIKE_IT",
  FUTURE_OPPORTUNITIES: "FUTURE_OPPORTUNITIES",
} as const;

export type CareerChangeConcern =
  (typeof CAREER_CHANGE_CONCERN)[keyof typeof CAREER_CHANGE_CONCERN];

export const CAREER_TIMELINE = {
  ZERO_TO_THREE_MONTHS: "ZERO_TO_THREE_MONTHS",
  THREE_TO_SIX_MONTHS: "THREE_TO_SIX_MONTHS",
  SIX_TO_TWELVE_MONTHS: "SIX_TO_TWELVE_MONTHS",
  OVER_A_YEAR: "OVER_A_YEAR",
  JUST_EXPLORING: "JUST_EXPLORING",
} as const;

export type CareerTimeline = (typeof CAREER_TIMELINE)[keyof typeof CAREER_TIMELINE];

export const CAREER_ASPECT = {
  HIGHER_INCOME_POTENTIAL: "HIGHER_INCOME_POTENTIAL",
  WORK_LIFE_BALANCE: "WORK_LIFE_BALANCE",
  MEANINGFUL_WORK: "MEANINGFUL_WORK",
  CAREER_GROWTH: "CAREER_GROWTH",
  JOB_SECURITY: "JOB_SECURITY",
} as const;

export type CareerAspect = (typeof CAREER_ASPECT)[keyof typeof CAREER_ASPECT];

export const QUESTIONNAIRE_DETAIL = {
  CAREER_GOAL: "CAREER_GOAL",
  CAREER_CHANGE_CONCERN: "CAREER_CHANGE_CONCERN",
  CAREER_TIMELINE: "CAREER_TIMELINE",
  CAREER_ASPECTS_RANKING: "CAREER_ASPECTS_RANKING",
  DIG_DEEPER_PRESENTED: "DIG_DEEPER_PRESENTED",
  JOB_ENJOYMENT: "JOB_ENJOYMENT",
  JOB_DISLIKE: "JOB_DISLIKE",
  CAREER_ASPECTS_DESIRED: "CAREER_ASPECTS_DESIRED",
} as const;

export type AI_PROMPT = {
  COACH_SUMMARY: {
    skipperType: SkipperType;
  };
  QOTD_INSIGHT: string;
};

export const SKIPPER_TYPE = {
  BUILDER: "BUILDER",
  MENTOR: "MENTOR",
  CAPTAIN: "CAPTAIN",
  SCIENTIST: "SCIENTIST",
  PLANNER: "PLANNER",
  HERO: "HERO",
  HOST: "HOST",
  NAVIGATOR: "NAVIGATOR",
  CREATOR: "CREATOR",
  OPTIMIZER: "OPTIMIZER",
  TEAMMATE: "TEAMMATE",
  STAR: "STAR",
  CONNECTOR: "CONNECTOR",
} as const;

export type SkipperType = (typeof SKIPPER_TYPE)[keyof typeof SKIPPER_TYPE];

export type CoachSummary = {
  skipperType: SkipperType;
  strengths: string[];
  uniqueTrait: string;
  summary: string;
};
